import React, { Component } from 'react';
import queryString from 'query-string';
import Styles from "../Styles.js";
import { GlobalContext } from '../global-context.js';

class PromotePIContainer extends Component {
    static contextType = GlobalContext;

    constructor(props) {
        super(props);
        this.state = {
            id: null,
            project: null,
            eppn: null,
        };
    }

    componentDidMount() {
        const values = queryString.parse(this.props.location.search);
        const pid = values.project;
        fetch(`/api/project/${pid}`)
            .then(res => res.json())
            .then(proj => {
                this.setState({
                    id: pid,
                    project: proj,
                    eppn: values.member,
                });
            });
    }

    confirmPromotion = async () => {
      const { project, eppn } = this.state;
      const { setGlobalError } = this.context;
      const { navigate } = this.props;
      let member_error = undefined;
      // let updated = undefined;
      const endpoint = `/api/project/${project.id}/promotemember/${eppn}`;

      let res = await fetch(endpoint, { method: 'PUT' }).catch((error) => {
          console.log("ERROR in promote member:", error);
      });
      if (!res || res.ok === false) {
            let errdata = await res.json();
            console.log("ERROR in response", errdata);
            member_error = errdata.message || errdata;
            setGlobalError(member_error);
      } else {
          console.log("200");
      }

      navigate(`project/${project.id}`);
    }

    render() {
        if (!(this.state.id) || !(this.state.project)) {
            return null
        }
        const { project, eppn } = this.state;
        // const { config, person } = this.context;

        return (
            <div style={{padding: "20px"}}>
              <Styles>
                <h1>{project.title}</h1>
                <h3>This action will promote {eppn} to PI for this project, and demote you to a member.</h3>
                <div className="link" onClick={() => this.confirmPromotion()}>
                    Confirm
                </div>
              </Styles>
            </div>
        );
    }
}

export default PromotePIContainer;
